module.exports = __webpack_public_path__ + "img/home-map-location_en.172141c5.jpg";